import * as z from "zod";

/**
 * Lock configuration for inline nodes (variable, mention).
 */
const InlineLockAttrsSchema_ = z.object({
  lockDelete: z.boolean().optional(),
  lockEdit: z.boolean().optional(),
});

/** Base type from schema inference (no index signature) */
type InlineLockAttrsBase = z.infer<typeof InlineLockAttrsSchema_>;

/** Full type with index signature */
export type InlineLockAttrs = InlineLockAttrsBase & { [key: string]: unknown };

export const InlineLockAttrsSchema: z.ZodType<InlineLockAttrs> =
  InlineLockAttrsSchema_;

/**
 * Lock configuration for branch-level controls.
 */
const BranchLockAttrsSchema_ = z.object({
  lockDelete: z.boolean().optional(),
  lockCondition: z.boolean().optional(),
  lockConditionType: z.boolean().optional(),
  lockAddStep: z.boolean().optional(),
});

/** Base type from schema inference (no index signature) */
type BranchLockAttrsBase = z.infer<typeof BranchLockAttrsSchema_>;

/** Full type with index signature */
export type BranchLockAttrs = BranchLockAttrsBase & { [key: string]: unknown };

export const BranchLockAttrsSchema: z.ZodType<BranchLockAttrs> =
  BranchLockAttrsSchema_;

/**
 * Lock configuration for step-level controls.
 */
const StepLockAttrsSchema_ = z.object({
  lockDelete: z.boolean().optional(),
  lockType: z.boolean().optional(),
  lockContent: z.boolean().optional(),
  lockSelection: z.boolean().optional(),
});

/** Base type from schema inference (no index signature) */
type StepLockAttrsBase = z.infer<typeof StepLockAttrsSchema_>;

/** Full type with index signature */
export type StepLockAttrs = StepLockAttrsBase & { [key: string]: unknown };

export const StepLockAttrsSchema: z.ZodType<StepLockAttrs> =
  StepLockAttrsSchema_;

/**
 * Lock configuration for the entire conditional block.
 */
const ConditionalLockAttrsSchema_ = z.object({
  lockAddBranch: z.boolean().optional(),
  lockDelete: z.boolean().optional(),
});

/** Base type from schema inference (no index signature) */
type ConditionalLockAttrsBase = z.infer<typeof ConditionalLockAttrsSchema_>;

/** Full type with index signature */
export type ConditionalLockAttrs = ConditionalLockAttrsBase & {
  [key: string]: unknown;
};

export const ConditionalLockAttrsSchema: z.ZodType<ConditionalLockAttrs> =
  ConditionalLockAttrsSchema_;

/**
 * Lock configuration for locked block nodes (required placeholders).
 */
const BlockLockAttrsSchema_ = z.object({ lockDelete: z.boolean().optional() });

/** Base type from schema inference (no index signature) */
type BlockLockAttrsBase = z.infer<typeof BlockLockAttrsSchema_>;

/** Full type with index signature */
export type BlockLockAttrs = BlockLockAttrsBase & { [key: string]: unknown };

export const BlockLockAttrsSchema: z.ZodType<BlockLockAttrs> =
  BlockLockAttrsSchema_;

/**
 * Lock configuration for section block nodes.
 */
const SectionLockAttrsSchema_ = z.object({
  lockDelete: z.boolean().optional(),
  lockContent: z.boolean().optional(),
});

/** Base type from schema inference (no index signature) */
type SectionLockAttrsBase = z.infer<typeof SectionLockAttrsSchema_>;

/** Full type with index signature */
export type SectionLockAttrs = SectionLockAttrsBase & {
  [key: string]: unknown;
};

export const SectionLockAttrsSchema: z.ZodType<SectionLockAttrs> =
  SectionLockAttrsSchema_;
